export const GUIDELINE_USER_ROLE_REQUEST = 'GUIDELINE_USER_ROLE_REQUEST';
export const GUIDELINE_USER_ROLE_SUCCESS = 'GUIDELINE_USER_ROLE_SUCCESS';
export const GUIDELINE_USER_ROLE_EMPTY = 'GUIDELINE_USER_ROLE_EMPTY';
export const GUIDELINE_USER_ROLE_ERROR = 'GUIDELINE_USER_ROLE_ERROR';

export const GUIDELINE_USER_ROLE_ACCEPT = 'GUIDELINE_USER_ROLE_ACCEPT';
export const GUIDELINE_USER_ROLE_REJECT = 'GUIDELINE_USER_ROLE_REJECT';
export const GUIDELINE_USER_ROLE_CHANGE_REQUEST = 'GUIDELINE_USER_ROLE_CHANGE_REQUEST';
export const GUIDELINE_USER_ROLE_APPROVE = 'GUIDELINE_USER_ROLE_APPROVE';
